const domains = [
    `.${document.domain}`,
    '.sketch.com',
    'localhost',
    '127.0.0.1',
];

export { domains };
